import { render, staticRenderFns } from "./fluxo.vue?vue&type=template&id=58f358fa&scoped=true"
import script from "./fluxo.vue?vue&type=script&lang=js"
export * from "./fluxo.vue?vue&type=script&lang=js"
import style0 from "./fluxo.vue?vue&type=style&index=0&id=58f358fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f358fa",
  null
  
)

export default component.exports